import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import { ApolloQueryResult } from '@apollo/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CustomerQuery {
  customer: {
    created_at: boolean
    default_billing: boolean
    default_shipping: boolean
    email: boolean
    firstname: boolean
    gender: boolean
    is_subscribed: boolean
    lastname: boolean
    middlename: boolean
    prefix: boolean
    suffix: boolean
    taxvat: boolean
    [key: string]: any
    addresses: {
      city: boolean
      company: boolean
      country_id: boolean
      default_billing: boolean
      default_shipping: boolean
      extension_attributes: {
        attribute_code: boolean
        value: boolean
      }
      fax: boolean
      firstname: boolean
      id: boolean
      lastname: boolean
      middlename: boolean
      postcode: boolean
      prefix: boolean
      region: {
        region: boolean
        region_code: boolean
        region_id: boolean
      }
      street: boolean
      suffix: boolean
      telephone: boolean
      vat_id: boolean
      [key: string]: any
    }
  }
}

export const customer = {
  customer: {
    created_at: true,
    default_billing: true,
    default_shipping: true,
    email: true,
    firstname: true,
    gender: true,
    is_subscribed: true,
    lastname: true,
    middlename: true,
    prefix: true,
    suffix: true,
    taxvat: true,
    addresses: {
      city: true,
      company: true,
      country_id: true,
      default_billing: true,
      default_shipping: true,
      extension_attributes: {
        attribute_code: true,
        value: true
      },
      fax: true,
      firstname: true,
      id: true,
      lastname: true,
      middlename: true,
      postcode: true,
      prefix: true,
      region: {
        region: true,
        region_code: true,
        region_id: true
      },
      street: true,
      suffix: true,
      telephone: true,
      vat_id: true
    }
  }
}

export type GetCustomerQuery = () => Promise<ApolloQueryResult<any>>

export const createCustomerQuery = ({ getQueries }: ServiceDependencies): GetCustomerQuery => async () => {
  const query = getQueries().customerQuery

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  })
}
